import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=706b8d94&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b8d94",
  null
  
)

export default component.exports